import { DefaultButton, Icon, List, PrimaryButton, TextField } from "@fluentui/react";
import React, { useState } from "react";
import {
    defaultButtonStyles, primaryButtonStyles, textFieldStyles
} from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";

export default function ScanInvoicePrintView() {
    const [text, setText] = useState<string>("");
    const [list, setList] = useState<string[]>([]);
    const [listHash, setListHash] = useState<number>(0);

    const width6 = Utils.getColumnWidth(6);
    const width12 = Utils.getColumnWidth(12);

    const onSubmit = () => {
        window.open("/invoice-prints/label/" + getInvoiceTexts(), "_blank");
    }

    const onRenderRow = (item?: string, index?: number, isScrolling?: boolean) => {
        let width12 = Utils.getColumnWidth(12);

        return <div className="ms-Grid-row pt-20">
            <div className={width12}>
                <Icon
                    iconName="trash"
                    className="firmed pointer"
                    onClick={() => onDelete(index ?? 0)}
                />

                <span className="pl-10">{item}</span>
            </div>
        </div>;
    }

    const onTextChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        setText(value ?? "");
    }

    const onTextKeyDown = (event: any) => {
        if (event.keyCode === 13) {
            if (!text) return;

            let values = text.split(",");
            let newList = list;

            for (var i = 0; i < values.length; i++) {
                let val = values[i];

                let isExists = list.filter(
                    (item: string, index: number) => item === val
                ).length > 0;

                if (!isExists) {
                    newList.push(val);
                }
            }

            setList(newList);
            setListHash(Utils.getRandomKey());
            setText("");
        }
    }

    const onDelete = (index: number) => {
        if (index < 0 || index > list.length) return;

        const item = list[index];
        const msg = "Are you sure to remove the invoice " + item + " from the list?";

        if (window.confirm(msg)) {
            const newList = list.splice(index, 1);
            setList(newList);
            setListHash(Utils.getRandomKey());
        }
    }

    const onClearAll = () => {
        if (window.confirm("Are you sure to remove all invoices in the list?")) {
            setList([]);
            setListHash(Utils.getRandomKey());
        }
    }

    const getInvoiceTexts = () => {
        return list.join(",");
    }

    const textInput = () => {
        return <>
            <TextField label="Invoice #" value={text} required
                onChange={onTextChange}
                onKeyDown={onTextKeyDown}
                styles={textFieldStyles}
            />
        </>;
    }

    return <div className="ms-Grid left">
        <div className="ms-Grid-row">
            <div className={width12}>{textInput()}</div>
        </div>

        <List items={list} key={listHash} onRenderCell={onRenderRow} />

        <div className="ms-Grid-row pv-20">
            <div className={width6}>
                <DefaultButton
                    onClick={onClearAll}
                    style={{ width: "100%" }}
                    styles={defaultButtonStyles}
                >Clear All</DefaultButton>
            </div>
            <div className={width6}>
                <PrimaryButton
                    onClick={onSubmit}
                    style={{ width: "100%" }}
                    styles={primaryButtonStyles}
                >Print Labels</PrimaryButton>
            </div>
        </div>
    </div>;
}